import { get, post, put, remove } from "./api";

export async function getDashboards(workspaceId: string) {
  const { data = {} } = await get({
    path: `/workspaces/${workspaceId}/dashboards`,
  });
  return data;
}

export async function saveDashboard(workspaceId: string, dashboard: any) {
  if (dashboard.id) {
    const { data = {} } = await put({
      path: `/workspaces/${workspaceId}/dashboards/${dashboard.id}`,
      data: dashboard,
    });
    return data;
  }
  const { data = {} } = await post({
    path: `/workspaces/${workspaceId}/dashboards`,
    data: dashboard,
  });
  return data;
}

export async function deleteDashboard(workspaceId: string, dashboardId: string) {
  await remove({
    path: `/workspaces/${workspaceId}/dashboards/${dashboardId}`,
  });
  return { dashboardId };
}

export async function saveWidget(workspaceId: string, dashboardId: string, widget: any) {
  const { data = {} } = await put({
    path: `/workspaces/${workspaceId}/dashboard/${dashboardId}/widgets`,
    data: widget,
  });
  return data;
}

export async function deleteWidget(workspaceId: string, dashboardId: string, widgetId: string) {
  await remove({
    path: `/workspaces/${workspaceId}/dashboard/${dashboardId}/widgets/${widgetId}`,
  });
  return { widgetId };
}

export async function getReports(workspaceId: string) {
  const { data = [] } = await get({
    path: `/workspaces/${workspaceId}/reports`,
  });
  return data;
}

// Get single report by id (detail-first flow)
export async function getReport(workspaceId: string, reportId: string) {
  const path = `/workspaces/${workspaceId}/reports/${reportId}`;
  const { data = {} } = await get({ path });
  return data;
}

export async function saveReport(workspaceId: string, report: any) {
  const { data = [] } = await post({
    path: `/workspaces/${workspaceId}/reports`,
    data: report,
  });
  return data;
}

export async function deleteReport(workspaceId: string, reportId: string) {
  const { data = {} } = await remove({
    path: `/workspaces/${workspaceId}/reports/${reportId}`,
  });
  return data;
}
